// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"e21137fb","61":"2ed0bc16","126":"7bf601a2","243":"88e27480","573":"e49f1372","981":"c654dc5c"}[chunkId] + ".chunk.js";
};